export type ShipmentStatusColorMap = {
  [key: number]: {
    bgColor: string;
    textColor: string;
  };
};

export const statusColorMap: ShipmentStatusColorMap = {
  100000000: {
    bgColor: 'bg-green-500',
    textColor: 'text-white',
  },
  100000001: {
    bgColor: 'bg-blue-500',
    textColor: 'text-white',
  },
  100000002: {
    bgColor: 'bg-yellow-500',
    textColor: 'text-white',
  },
  100000003: {
    bgColor: 'bg-purple-500',
    textColor: 'text-white',
  },
  100000004: {
    bgColor: 'bg-cyan-500',
    textColor: 'text-white',
  },
  100000005: {
    bgColor: 'bg-indigo-500',
    textColor: 'text-white',
  },
  100000006: {
    bgColor: 'bg-pink-500',
    textColor: 'text-white',
  },
  100000007: {
    bgColor: 'bg-red-500',
    textColor: 'text-white',
  },
};
